import { render, staticRenderFns } from "./wechatSet.vue?vue&type=template&id=44881318&scoped=true&"
import script from "./wechatSet.vue?vue&type=script&lang=js&"
export * from "./wechatSet.vue?vue&type=script&lang=js&"
import style0 from "./wechatSet.vue?vue&type=style&index=0&id=44881318&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44881318",
  null
  
)

export default component.exports